module.exports = __webpack_public_path__ + "img/servico-exemplo.50b5631e.jpg";